/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_line_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Everything is computed locally in your browser, so your data stays on your device.`)
};

const es_line_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Todo se calcula localmente en tu navegador, así que tus datos permanecen en tu dispositivo.`)
};

const de_line_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein. Alles wird lokal in Ihrem Browser berechnet, sodass Ihre Daten auf Ihrem Gerät bleiben.`)
};

const nl_line_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nee. Alles wordt lokaal in je browser berekend, zodat je data op je apparaat blijft.`)
};

const fr_line_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non. Tout est calculé localement dans votre navigateur, donc vos données restent sur votre appareil.`)
};

const it_line_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Tutto viene calcolato localmente nel tuo browser, quindi i tuoi dati restano sul tuo dispositivo.`)
};

const pt_br2_line_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. Tudo é calculado localmente no seu navegador, então seus dados permanecem no seu dispositivo.`)
};

const pt_line_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. Tudo é calculado localmente no seu navegador, pelo que os seus dados permanecem no seu dispositivo.`)
};

const ja_line_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ。すべてブラウザ内でローカルに計算されるため、データは端末上に留まります。`)
};

const zh_line_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不会。所有计算都在你的浏览器本地完成，你的数据始终保留在你的设备上。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const line_faq_a4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.line_faq_a4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("line_faq_a4", locale)
	if (locale === "en") return en_line_faq_a4(inputs)
	if (locale === "es") return es_line_faq_a4(inputs)
	if (locale === "de") return de_line_faq_a4(inputs)
	if (locale === "nl") return nl_line_faq_a4(inputs)
	if (locale === "fr") return fr_line_faq_a4(inputs)
	if (locale === "it") return it_line_faq_a4(inputs)
	if (locale === "pt-BR") return pt_br2_line_faq_a4(inputs)
	if (locale === "pt") return pt_line_faq_a4(inputs)
	if (locale === "ja") return ja_line_faq_a4(inputs)
	return zh_line_faq_a4(inputs)
};